import { defineMessages } from 'react-intl';
export default defineMessages({
    agroMeteorology: {
        id: 'reports.agroMeteorology',
        defaultMessage: 'Agrometeorology'
    },
    analysis: {
        id: 'reports.analysis',
        defaultMessage: 'Analysis'
    },
    annualCumulativeRainfallComparison: {
        id: 'reports.annualCumulativeRainfallComparison',
        defaultMessage: 'Annual Cumulative Rainfall Comparison'
    },
    chartsAndTable: {
        id: 'reports.chartsAndTable',
        defaultMessage: 'Charts and table'
    },
    cumulativeRainfall: {
        id: 'reports.cumulativeRainfall',
        defaultMessage: 'Cumulative rainfall'
    },
    cumulativeRainfallDescription: {
        id: 'reports.cumulativeRainfallDescription',
        defaultMessage: 'Track total rainfall accumulating over the selected period.'
    },
    annualHeatingDurationComparison: {
        id: 'reports.annualHeatingDurationComparison',
        defaultMessage: 'Annual heating duration comparison'
    },
    annualHeatingEfficiency: {
        id: 'reports.annualHeatingEfficiency',
        defaultMessage: 'Annual heating efficiency'
    },
    annualIndoorComparison: {
        id: 'reports.annualIndoorComparison',
        defaultMessage: 'Annual Indoor Comparison'
    },
    annualOutdoorComparison: {
        id: 'reports.annualOutdoorComparison',
        defaultMessage: 'Annual Outdoor Comparison'
    },
    annualOutdoorReport: {
        id: 'reports.annualOutdoorReport',
        defaultMessage: 'Annual Outdoor Report'
    },
    annualReport: {
        id: 'reports.annualReport',
        defaultMessage: 'Annual Report'
    },
    annualSolarReport: {
        id: 'reports.annualSolarReport',
        defaultMessage: 'Annual solar report'
    },
    annualWaterBalance: {
        id: 'reports.annualWaterBalance',
        defaultMessage: 'Annual water balance'
    },
    annualWaterBalanceDescription: {
        id: 'reports.annualWaterBalanceDescription',
        defaultMessage: 'The water balance (simplified version, only Rain and evapotranspiration are used) helps manage water supply'
    },
    annualWaterBalanceCarryOver: {
        id: 'reports.annualWaterBalanceCarryOver',
        defaultMessage: 'Carry over {year} ({value})'
    },
    avgHumidity: {
        id: 'reports.avgHumidity',
        defaultMessage: 'Average humidity'
    },
    avgMetric: {
        id: 'reports.avgMetric',
        defaultMessage: 'Average {metric}'
    },
    avgMaxTemperature: {
        id: 'reports.avgMaxTemperature',
        defaultMessage: 'Average T°max'
    },
    avgMinTemperature: {
        id: 'reports.avgMinTemperature',
        defaultMessage: 'Average T°min'
    },
    avgPressure: {
        id: 'reports.avgPressure',
        defaultMessage: 'Average pressure'
    },
    avgTemperature: {
        id: 'reports.avgTemperature',
        defaultMessage: 'Average temperature'
    },
    climateNormals: {
        id: 'reports.climateNormals',
        defaultMessage: 'Climate normals'
    },
    climateNormalStandardLabel: {
        id: 'reports.climateNormalStandardLabel',
        defaultMessage: 'Standard normal ({period})'
    },
    climateNormalPeriodOfRecord: {
        id: 'reports.climateNormalPeriodOfRecord',
        defaultMessage: 'Period of record ({years, plural, one {# year} other {# years}})'
    },
    climateTrendPerDecade: {
        id: 'reports.climateTrendPerDecade',
        defaultMessage: 'Temperature trend: {value} per decade over {years, plural, one {# year} other {# years}}'
    },
    coldestMonthRanking: {
        id: 'reports.coldestMonthRanking',
        defaultMessage: 'Coldest {month} on record'
    },
    comfortable: {
        id: 'reports.comfortable',
        defaultMessage: 'Comfortable (45% {lessThan} Humidity ≤ 60%)'
    },
    dailyMaxRainfall: {
        id: 'reports.dailyMaxRainfall',
        defaultMessage: 'Daily Max. rainfall'
    },
    dataExport: {
        id: 'reports.dataExport',
        defaultMessage: 'Export data'
    },
    dataExportXlsxFormatDescription: {
        id: 'reports.dataExportXlsxFormatDescription',
        defaultMessage: "Export all of your station's data in Excel format (*.xlsx). Once you click on the button, you will receive an email with the processed data after a few minutes."
    },
    daysWithFrost: {
        id: 'reports.daysWithFrost',
        defaultMessage: 'Days with frost'
    },
    daysWithHeavyRain: {
        id: 'reports.daysWithHeavyRain',
        defaultMessage: 'Days with heavy rain (≥ {threshold})'
    },
    frostDays: {
        id: 'reports.frostDays',
        defaultMessage: 'Frost days'
    },
    iceDays: {
        id: 'reports.iceDays',
        defaultMessage: 'Ice days'
    },
    longestDrySpell: {
        id: 'reports.longestDrySpell',
        defaultMessage: 'Longest dry spell'
    },
    longestWetSpell: {
        id: 'reports.longestWetSpell',
        defaultMessage: 'Longest wet spell'
    },
    recordClimatologicalDay: {
        id: 'reports.recordClimatologicalDay',
        defaultMessage: 'Climatological day (06–06 UTC)'
    },
    recordClimDayBody: {
        id: 'reports.recordClimDayBody',
        defaultMessage: 'Rain is totalled per calendar day here, midnight to midnight at the station. Weather services total it from 06:00 to 06:00 UTC, so a storm either side of midnight can make a different day the wettest.'
    },
    recordDailyRain: {
        id: 'reports.recordDailyRain',
        defaultMessage: 'Wettest day'
    },
    recordFromHourlyReadings: {
        id: 'reports.recordFromHourlyReadings',
        defaultMessage: 'From hourly readings'
    },
    recordHigh: {
        id: 'reports.recordHigh',
        defaultMessage: 'Record high'
    },
    recordLow: {
        id: 'reports.recordLow',
        defaultMessage: 'Record low'
    },
    recordOfficialBody: {
        id: 'reports.recordOfficialBody',
        defaultMessage: 'The weather service publishes a daily high and low for this station, read from maximum and minimum thermometers. They catch short peaks that hourly readings miss, so they replace the values worked out from hourly readings.'
    },
    recordOfficialValue: {
        id: 'reports.recordOfficialValue',
        defaultMessage: 'Official value'
    },
    recordWindGust: {
        id: 'reports.recordWindGust',
        defaultMessage: 'Strongest wind gust'
    },
    recordSheetTitle: {
        id: 'reports.recordSheetTitle',
        defaultMessage: 'About these records'
    },
    recordsAndClimatology: {
        id: 'reports.recordsAndClimatology',
        defaultMessage: 'Records & climate'
    },
    recordsSince: {
        id: 'reports.recordsSince',
        defaultMessage: 'Records since {date}'
    },
    onThisDayInHistory: {
        id: 'reports.onThisDayInHistory',
        defaultMessage: 'On this day in history'
    },
    onThisDayCoverage: {
        id: 'reports.onThisDayCoverage',
        defaultMessage: '{years, plural, one {# year since {firstYear}} other {# years since {firstYear}}}'
    },
    onThisDayRainSince: {
        id: 'reports.onThisDayRainSince',
        defaultMessage: 'rain since {year}'
    },
    onThisDayEveryYear: {
        id: 'reports.onThisDayEveryYear',
        defaultMessage: 'Every {date} on record'
    },
    onThisDayRain: {
        id: 'reports.onThisDayRain',
        defaultMessage: 'Rain on {date}'
    },
    onThisDayNormal: {
        id: 'reports.onThisDayNormal',
        defaultMessage: 'Normal day: {min} to {max}'
    },
    onThisDayTied: {
        id: 'reports.onThisDayTied',
        defaultMessage: 'tied {years}'
    },
    onThisDayTiedMore: {
        id: 'reports.onThisDayTiedMore',
        defaultMessage: 'tied {years} +{count}'
    },
    onThisDaySingleReading: {
        id: 'reports.onThisDaySingleReading',
        defaultMessage: '{count, plural, one {# year has} other {# years have}} a single reading that day and {count, plural, one {is} other {are}} not drawn.'
    },
    onThisDayOneReading: {
        id: 'reports.onThisDayOneReading',
        defaultMessage: '1 reading'
    },
    onThisDayNoDataRun: {
        id: 'reports.onThisDayNoDataRun',
        defaultMessage: '{start}–{end} · no data ({count, plural, one {# year} other {# years}})'
    },
    onThisDayChartRule: {
        id: 'reports.onThisDayChartRule',
        defaultMessage: 'The year-by-year chart appears once {count, plural, one {# year} other {# years}} of {date} are recorded.'
    },
    onThisDayNoYears: {
        id: 'reports.onThisDayNoYears',
        defaultMessage: 'No complete {date} on record yet'
    },
    onThisDayNoYearsDetail: {
        id: 'reports.onThisDayNoYearsDetail',
        defaultMessage: 'This page fills in from the first {date} the station records in full.'
    },
    onThisDayDataSince: {
        id: 'reports.onThisDayDataSince',
        defaultMessage: 'This station has data since {date}.'
    },
    onThisDayOpenRecords: {
        id: 'reports.onThisDayOpenRecords',
        defaultMessage: 'Open Records & climate'
    },
    onThisDaySlowLoad: {
        id: 'reports.onThisDaySlowLoad',
        defaultMessage: 'Reading {years, plural, one {# year} other {# years}} of {date}. The first look at a date can take up to 20 seconds.'
    },
    onThisDaySlowLoadGeneric: {
        id: 'reports.onThisDaySlowLoadGeneric',
        defaultMessage: "Reading this station's history of {date}. The first look at a date can take up to 20 seconds."
    },
    onThisDayLeaveOk: {
        id: 'reports.onThisDayLeaveOk',
        defaultMessage: 'You can leave this screen; it keeps loading.'
    },
    onThisDayPickTitle: {
        id: 'reports.onThisDayPickTitle',
        defaultMessage: 'Pick a day'
    },
    onThisDayPickHint: {
        id: 'reports.onThisDayPickHint',
        defaultMessage: 'Changes the day shown'
    },
    onThisDayChartSummary: {
        id: 'reports.onThisDayChartSummary',
        defaultMessage: '{years, plural, one {# year} other {# years}} with temperature, {first} to {last}. Record high {high} in {highYears}, record low {low} in {lowYear}. Normal day {min} to {max}.'
    },
    onThisDayYearSummary: {
        id: 'reports.onThisDayYearSummary',
        defaultMessage: '{year}: low {min}, high {max}, rain {rain}'
    },
    onThisDayRainNotMeasured: {
        id: 'reports.onThisDayRainNotMeasured',
        defaultMessage: 'not measured'
    },
    onThisDayOneReadingSummary: {
        id: 'reports.onThisDayOneReadingSummary',
        defaultMessage: '{year}: {value}, 1 reading, rain {rain}'
    },
    onThisDayRainOnlySummary: {
        id: 'reports.onThisDayRainOnlySummary',
        defaultMessage: '{year}: rain {rain}'
    },
    onThisDayRainSummary: {
        id: 'reports.onThisDayRainSummary',
        defaultMessage: 'Rain on {date}. Wettest day {value} in {years}.'
    },
    onThisDayYearTied: {
        id: 'reports.onThisDayYearTied',
        defaultMessage: '{year} ({tied})'
    },
    onThisDayNoYearSelected: {
        id: 'reports.onThisDayNoYearSelected',
        defaultMessage: 'No year selected'
    },
    onThisDayLoadFailed: {
        id: 'reports.onThisDayLoadFailed',
        defaultMessage: 'Could not load {date}. Check your connection and try again.'
    },
    onThisDayRetry: {
        id: 'reports.onThisDayRetry',
        defaultMessage: 'Try again'
    },
    onThisDayGapNoData: {
        id: 'reports.onThisDayGapNoData',
        defaultMessage: 'no data'
    },
    summerDays: {
        id: 'reports.summerDays',
        defaultMessage: 'Summer days'
    },
    warmestMonthRanking: {
        id: 'reports.warmestMonthRanking',
        defaultMessage: 'Warmest {month} on record'
    },
    monthlyAverageCountdown: {
        id: 'reports.monthlyAverageCountdown',
        defaultMessage: '{days, plural, one {# more day this month} other {# more days this month}}'
    },
    monthlyAverageCountdownDetail: {
        id: 'reports.monthlyAverageCountdownDetail',
        defaultMessage: "Then this month's average and ranking appear."
    },
    monthlyAverageRule: {
        id: 'reports.monthlyAverageRule',
        defaultMessage: 'Monthly averages and rankings appear once a calendar month has {days, plural, one {# day} other {# days}} recorded.'
    },
    daysOfData: {
        id: 'reports.daysOfData',
        defaultMessage: '{days, plural, one {# day of data} other {# days of data}}'
    },
    monthsOfData: {
        id: 'reports.monthsOfData',
        defaultMessage: '{months, plural, one {# month of data} other {# months of data}}'
    },
    yearsOfData: {
        id: 'reports.yearsOfData',
        defaultMessage: '{years, plural, one {# year of data} other {# years of data}}'
    },
    daysWithStrongFrost: {
        id: 'reports.daysWithStrongFrost',
        defaultMessage: 'Days with strong frost'
    },
    daysWithoutThaw: {
        id: 'reports.daysWithoutThaw',
        defaultMessage: 'Days without thaw'
    },
    emailSent: {
        id: 'reports.emailSent',
        defaultMessage: 'An email has been sent to your mailbox'
    },
    grasslandTemperatureSum: {
        id: 'reports.grasslandTemperatureSum',
        defaultMessage: 'Grassland temperature sum'
    },
    grasslandTemperatureSumDescription: {
        id: 'reports.grasslandTemperatureSumDescription',
        defaultMessage: 'If the sum of {threshold} is exceeded in spring, the sustainable start of vegetation has been reached (works in Europe)'
    },
    growingDegreeDays: {
        id: 'reports.growingDegreeDays',
        defaultMessage: 'Growing degree days'
    },
    highPressure: {
        id: 'reports.highPressure',
        defaultMessage: 'Anticyclone (Average Pressure ≥ {threshold})'
    },
    indoorReport: {
        id: 'reports.indoorReport',
        defaultMessage: 'Indoor Report'
    },
    keyFacts: {
        id: 'reports.keyFacts',
        defaultMessage: 'Key Facts'
    },
    longestRunOfRainyDays: {
        id: 'reports.longestRunOfRainyDays',
        defaultMessage: 'Longest run of rainy days'
    },
    longestRunWithoutRun: {
        id: 'reports.longestRunWithoutRun',
        defaultMessage: 'Longest run without rain'
    },
    lowPressure: {
        id: 'reports.lowPressure',
        defaultMessage: 'Low Pressure (Average Pressure {lessThan} {threshold})'
    },
    maxHumidity: {
        id: 'reports.maxHumidity',
        defaultMessage: 'Maximum humidity'
    },
    maxMetric: {
        id: 'reports.maxMetric',
        defaultMessage: 'Maximum {metric}'
    },
    maxPressure: {
        id: 'reports.maxPressure',
        defaultMessage: 'Maximum pressure'
    },
    maxTempGreaterThan: {
        id: 'reports.maxTempGreaterThan',
        defaultMessage: 'T°max ≥'
    },
    maxTempMagnitude24h: {
        id: 'reports.maxTempMagnitude24h',
        defaultMessage: 'Maximum Magnitude (/24H)'
    },
    maxTemperature: {
        id: 'reports.maxTemperature',
        defaultMessage: 'Maximum temperature'
    },
    minHumidity: {
        id: 'reports.minHumidity',
        defaultMessage: 'Minimum humidity'
    },
    minMetric: {
        id: 'reports.minMetric',
        defaultMessage: 'Minimum {metric}'
    },
    minPressure: {
        id: 'reports.minPressure',
        defaultMessage: 'Minimum pressure'
    },
    minTempMagnitude24h: {
        id: 'reports.minTempMagnitude24h',
        defaultMessage: 'Minimum Magnitude (/24H)'
    },
    minTemperature: {
        id: 'reports.minTemperature',
        defaultMessage: 'Minimum temperature'
    },
    monthlyHeatingEfficiency: {
        id: 'reports.monthlyHeatingEfficiency',
        defaultMessage: 'Monthly heating efficiency'
    },
    monthlyOutdoorReport: {
        id: 'reports.monthlyOutdoorReport',
        defaultMessage: 'Monthly Outdoor Report'
    },
    monthlyReport: {
        id: 'reports.monthlyReport',
        defaultMessage: 'Monthly Report'
    },
    monthlySolarReport: {
        id: 'reports.monthlySolarReport',
        defaultMessage: 'Monthly solar report'
    },
    monthlyWindReport: {
        id: 'reports.monthlyWindReport',
        defaultMessage: 'Monthly Wind Report'
    },
    numberOfDays: {
        id: 'reports.numberOfDays',
        defaultMessage: 'Number of Days'
    },
    outdoorReport: {
        id: 'reports.outdoorReport',
        defaultMessage: 'Outdoor Report'
    },
    rainfall: {
        id: 'reports.rainfall',
        defaultMessage: 'Rainfall'
    },
    rainyDays: {
        id: 'reports.rainyDays',
        defaultMessage: 'Rainy days'
    },
    relativelyWet: {
        id: 'reports.relativelyWet',
        defaultMessage: 'Relatively wet (60% {lessThan} Humidity ≤ 80%)'
    },
    sendEmail: {
        id: 'reports.sendEmail',
        defaultMessage: 'Send email'
    },
    overviewSection: {
        id: 'reports.overviewSection',
        defaultMessage: 'Overview'
    },
    sectionReportCount: {
        id: 'reports.sectionReportCount',
        defaultMessage: '{count, plural, one {# report} other {# reports}}'
    },
    tooDry: {
        id: 'reports.tooDry',
        defaultMessage: 'Too dry (Humidity ≤ 45%)'
    },
    tooWet: {
        id: 'reports.tooWet',
        defaultMessage: 'Too wet (Humidity {greaterThan} 80%)'
    },
    tropicalNights: {
        id: 'reports.tropicalNights',
        defaultMessage: 'Tropical nights'
    },
    unlockPremiumSubtitle: {
        id: 'reports.unlockPremiumSubtitle',
        defaultMessage: 'Included with SmartMixin Premium'
    },
    unlockPremiumTitle: {
        id: 'reports.unlockPremiumTitle',
        defaultMessage: 'Unlock {count, plural, one {# premium feature} other {# premium features}}'
    },
    waterBalance: {
        id: 'reports.waterBalance',
        defaultMessage: 'Water balance'
    },
    yearToDateTemperatureComparison: {
        id: 'reports.yearToDateTemperatureComparison',
        defaultMessage: 'Year-to-date temperature comparison'
    },
    tableScrollRegion: {
        id: 'reports.tableScrollRegion',
        defaultMessage: '{title}, scrolls horizontally'
    }
});
